module.exports = __webpack_public_path__ + "img/actAd.de20ba49.png";